import React, { Component } from 'react';
import moment from 'moment';
import { NavLink } from "mdbreact";
import CISIcon from '../../CISIcon';
import './Footer.css';
export default class Footer extends Component {
  render () {
    return (
      <div className="footer blue-text">
        <span className="footer-text float-left">
        <NavLink className="version-link" to="/BuildInfo">Version: { process.env.REACT_APP_VERSION }</NavLink>
          &emsp;
        Build Date: {moment(process.env.REACT_APP_BUILD_DATE, "YYYYMMDD_hh:mm:ss").format('MMMM Do YYYY, h:mm:ss a') } </span>
        Powered By React        
        <CISIcon name="react-logo" className="React-logo" />
        <span className="footer-text float-right">Created by Matthew D Clark&nbsp;</span>
      </div>
    );
  }
}